import { take, isEmpty } from 'lodash';
import filters from './filters';

export const listFilters = (query, options = {}) => {
  const delimiter = options.delimiter == null ? ' • ' : options.delimiter;

  let labels = [];

  if (!isEmpty(options.userBounds)) {
    labels.push('Map Drawing');
  }

  filters.forEach((filter) => {
    labels = labels.concat(filter.getLabels(query));
  });

  if (options.limit) {
    labels = take(labels, options.limit);
  }

  return labels.join(delimiter || '');
};


export const propertyTypeParams = (propertyTypes) => {
  if (propertyTypes.length > 0) {
    propertyTypes.forEach((type) => {
      // if subtypes are selected, remove parent property type from query
      const parentTypeId = type.charAt(0);
      if (type.length > 1 && propertyTypes.includes(parentTypeId)) {
        propertyTypes = propertyTypes.filter(pt => pt != parentTypeId);
      }
    });
  }
  return propertyTypes;
};
